import React from 'react';
import AdSense from 'react-adsense';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Button from 'react-bootstrap/Button';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
class ContentAds extends React.Component{
  render(){
    return(
      <Jumbotron>
      <AdSense.Google
        client='ca-pub-6551659254419770'
        slot='6164409281'
        style={{ display: 'block' }}
        layout='in-article'
        format='auto'
      />
      </Jumbotron>

    );
  }
}

export default ContentAds;
